class StatisticBlock extends HTMLElement {
  constructor() {
    super();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.counterNumbers();
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(this);
  }
  counterNumbers() {
    const titles = this.querySelectorAll('.statistic__title');
    titles.forEach((title) => {
      const targeted = title.getAttribute('data-target');
      const target = parseInt(title.getAttribute('data-target'));
      title.innerHTML = targeted;
      let count = 0;
      const interval = setInterval(() => {
        if (count <= target) {
          title.innerHTML = count;
          count++;
        } else {
          clearInterval(interval);
          title.innerHTML = targeted;
        }
      }, 1);
    });
  }
}
customElements.define('statistic-block', StatisticBlock);
